//@flow
import React, { Component } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { clientIdSelector } from 'common/redux/selectors/sessionSelector';

import { VehicleModelId } from 'common/models/internal/VehicleModelId';
import { MasterVehicleModel } from 'common/models/internal/MasterVehicleModel';

import { translate } from 'react-i18next';
import debounce from 'lodash/debounce';
import { bulkVehicleModelFetch } from 'common/middleware/api';

import EntityIdInput from 'common/entity/generic/EntityIdInput';

type Props = {
    disabled: boolean,
    isLoading: boolean,
    clientId: string,
    params: ?Object,
    vehicleModel: ?VehicleModelId,
    theme: Object,
    field: Object,
    vehicleModelFilters: (input: string) => Object,
    onChange: (?MasterVehicleModel) => void,
    entity: Object,
    render: Object,
    t: (string, ?Object) => string
};

type State = {
    vehicleModels: Array<VehicleModelId>
};

class VehicleModelIdInput extends Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            vehicleModels: []
        };
        this.loadOptions = debounce(this.loadOptions, 200);
    }

    loadOptions = (input: string, callback) => {
        const { clientId, params, vehicleModelFilters } = this.props;
        const filters = vehicleModelFilters(input);
        bulkVehicleModelFetch
            .post({ clientId, ...params }, { filters })
            .then((response: Object) => {
                const { vehicleModels } = response;
                this.setState({ vehicleModels });
                callback(vehicleModels);
            })
            .catch(() => {
                //Ignore the error
            });
    };

    onChange = value => {
        const { onChange } = this.props;

        let vehicleModel = null;
        if (value) {
            vehicleModel = MasterVehicleModel.fromJS(value);
        }
        onChange(vehicleModel);
    };

    render() {
        const { vehicleModels } = this.state;
        const {
            vehicleModel,
            field: { placeholder },
            t,
            render,
            ...rest
        } = this.props;
        return (
            <>
                <EntityIdInput
                    {...rest}
                    onChange={this.onChange}
                    options={vehicleModels}
                    value={vehicleModel}
                    placeholder={t(placeholder)}
                    loadOptions={this.loadOptions}
                />
                {render}
            </>
        );
    }
}

const mapStateToProps = (state, props) => {
    const clientId = clientIdSelector(state, props);
    return {
        clientId
    };
};

const withRedux = connect(mapStateToProps);
export default compose(
    withRedux,
    translate('entityManagement')
)(VehicleModelIdInput);
